import { instance } from '@app/api/axios';
import { useShowToaster } from '@shared/ui/messages/useToaster';
import { useRequestError } from '@app/api/useRequestError';
import { useDispatch } from 'react-redux';
import { fetchBankWallets } from '@app/store/slices/bankWalletsSlice';

export function useTransfer() {
  const showToaster = useShowToaster();
  const handleRequestError = useRequestError();
  const dispatch = useDispatch();

  const transfer = async (data) => {
    try {
      const res = await instance.post('/balance/transfer', data);
      showToaster('success', res?.data?.message);
      dispatch(fetchBankWallets());
      return true;
    } catch (err) {
      return handleRequestError(err);
    }
  };

  return { transfer };
}
